import React, { useReducer, Fragment, useEffect, useState } from "react";
import {
  defaultStateEntity,
  initializeCustodianEntity,
  CustodianEntityReducer,
  ValidateCodeTypes,
} from "./reducer";
import { Row, Col, Input, Button, Table } from "reactstrap";
import style from "./CustodianEntity.module.scss";
import LaddaButton, { EXPAND_RIGHT } from "react-ladda";
import classnames from "classnames";
import ModalConfirm from "../../Asset/Modals/ModalConfirm";
import { Field, Combobox } from "../Order/Field/Field";

const CustodianEntityCodeType = ({ openCodeType, ...props }) => {
  const [state, dispatch] = useReducer(
    CustodianEntityReducer,
    defaultStateEntity(),
    initializeCustodianEntity(props)
  );
  const [modal, setModal] = useState({ open: false, indexContact: 0 });
  const { errors, custodianCodeType, CodeTypeNames } = state;
  useEffect(() => {
    props.callApi("getCodeTypes", {}).then((response) => {
      dispatch({
        type: "SET_CUSTODIAN_CODE_TYPE",
        response,
      });
    });
  }, []);

  const confirmCodeType = () => {
    const errors = ValidateCodeTypes(state, props.CodeTypes, props.EditCodeType);
    if (errors == false) {
      dispatch({ type: "UPDATE_VALIDATION_CODE_FORM", errors });
      if (props.EditCodeType) {
        props.updateCodeType({ custodianCodeType });
        props.onChangeUpdate({
          EditCodeType: false,
        });
      } else {
        props.setCodeType({ custodianCodeType });
      }
      dispatch({ type: "RESET_CODE_TYPE" });
      props.onChangeUpdate({
        openCustodianEntityCodeType: false,
      });
    } else {
      dispatch({ type: "UPDATE_VALIDATION_CONTACT_FORM", errors });
    }
  };

  const onChangeCodeType = (fields) => dispatch({ type: "SET_CODE_TYPE", fields });

  const ClickEditCodeType = (e, index) => {
    props.onChangeUpdate({
      EditCodeType: true,
      IndexEditCodeType: index,
    });
    dispatch({ type: "GET_CODE_TYPE", e });
    props.onChangeUpdate({
      openCustodianEntityCodeType: true,
    });
  };

  const cancelCodeType = () => {
    dispatch({ type: "RESET_CODE_TYPE" });
    props.onChangeUpdate({
      EditCodeType: false,
      openCustodianEntityCodeType: false,
    });
  };

  const ClickDeleteCodeType = (e, index) => {
    setModal({ ...modal, open: true, indexContact: index });
  };

  const toggleModal = (name, props = {}) => {
    setModal({ ...modal, open: false });
  };

  const onConfirm = (name) => {
    props.deleteCodeType(modal.indexContact);
  };

  return (
    <div>
      <ModalConfirm
        open={modal.open}
        title={"Delete Code Type"}
        message={"Are you sure you want to delete Custodian Entity Code Type?"}
        toggle={() => toggleModal("confirm", {})}
        onConfirm={() => onConfirm()}
      />
      {openCodeType ? (
        <div className={style.edit}>
          <Row>
            <Col lg={6} xs={12}>
              <Field label={"Code Type"}>
                <Combobox
                  style={{ background: "#edf9ff", fontWeight: 500 }}
                  value={custodianCodeType.CodeTypeId || ""}
                  onChange={(v) => onChangeCodeType({ CodeTypeId: v })}
                  items={CodeTypeNames.map((e) => ({
                    id: e.CodeTypeId,
                    description: e.CodeTypeName,
                  }))}
                />
              </Field>
            </Col>
            <Col lg={6} xs={12}>
              <Field label={"Code Type Value"} error={errors.CodeTypeValue || errors.unique}>
                <Input
                  type={"text"}
                  placeholder={"Code Type value"}
                  value={custodianCodeType.CodeTypeValue || ""}
                  invalid={errors.CodeTypeValue}
                  onChange={(e) =>
                    onChangeCodeType({
                      CodeTypeValue: e.target.value,
                    })
                  }
                />
              </Field>
            </Col>
          </Row>

          <div className={style.actions}>
            <Button className={"btn-sm"} color="light" onClick={(e) => cancelCodeType()}>
              {true ? "Cancel" : "Close"}
            </Button>{" "}
            <LaddaButton
              className={classnames("btn-sm btn-ladda btn-primary")}
              onClick={() => confirmCodeType()}
              data-style={EXPAND_RIGHT}
            >
              {props.EditCodeType ? "Edit" : "Save"}
            </LaddaButton>
          </div>
        </div>
      ) : (
        <Fragment>
          <div className={`${style.table}`}>
            <Table responsive striped>
              <thead>
                <tr>
                  <th>Code Type</th>
                  <th>Code Value</th>
                  <th style={{ width: "1px" }}>Edit</th>
                  <th style={{ width: "1px" }}>Del.</th>
                </tr>
              </thead>
              {props.CodeTypes.length == 0 ? (
                <tbody>
                  <EmptyCodeTypes />
                </tbody>
              ) : (
                <tbody>
                  {CodeTypeNames &&
                    CodeTypeNames.length > 0 &&
                    props.CodeTypes &&
                    props.CodeTypes.map((c, index) => (
                      <React.Fragment>
                        {c.CodeTypeChangeType !== "Delete" && (
                          <tr style={{ textAlign: "end" }}>
                            <td>{CodeTypeNames.find((e) => e.CodeTypeId == c.CodeTypeId).CodeTypeName}</td>
                            <td>{c.CodeTypeValue}</td>
                            <td onClick={() => ClickEditCodeType(c, index)}>
                              <i class="fa fa-pencil" aria-hidden="true"></i>
                            </td>
                            <td onClick={() => ClickDeleteCodeType(c, index)}>
                              <i class="fa fa-close" aria-hidden="true"></i>
                            </td>
                          </tr>
                        )}
                      </React.Fragment>
                    ))}
                </tbody>
              )}
            </Table>
          </div>
        </Fragment>
      )}
    </div>
  );
};

const EmptyCodeTypes = () => (
  <tr className={style.empty}>
    <td colSpan="4">
      <h5 style={{ textAlign: "center" }}>No Code Types</h5>
    </td>
  </tr>
);

export function validationsCodeTypes() {
  return {
    CodeTypeId: { empty: true },
    CodeTypeValue: { empty: true },
  };
}

export default CustodianEntityCodeType;
